import Api from '../service/Api';

export default {
  findByName: name => Api.get(`alunos/nome/${name}`),
  findByRenach: renach => Api.get(`alunos/renach/${renach}`),
  findByCpf: cpf => Api.get(`alunos/${cpf}`),
  login: (cpf, renach) => Api.post('/alunos/login', { cpf, renach }),
  logout: (cpf, renach, token) => Api.post('/alunos/logout', { cpf, renach, token }),
  validaToken: token => Api.post('/alunos/validatoken', { token }),
  getProdutosMatriculas: renach => Api.get(`/alunos/${renach}/produtos`),
  setClass: ( cpf, idAula )=> Api.post('/setClass',{ cpf, idAula }),
  getLastClass: cpf => Api.post('/getLastClass',{ cpf }),
};
